function buildUrl(base, path) {
    if (!base || !path) return path || '';
    return `${base.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export { buildUrl };
